import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { Backdrop, CircularProgress, Avatar } from '@mui/material';

import { deleteCookie, staffCheckOut } from '@api';
import {
  useOrderContext,
  useAuthContext,
  useLoadingContext,
  useElementsCoordsContext,
  useDrawerContext,
} from '@hooks';

import penguin from '@assets/penguin.png';
import { Menu } from '@mui/icons-material';
import arrow from '@assets/arrow-white.png';

import AvatarMenu from './components/AvatarMenu/AvatarMenu';
import OrderCount from './components/OrderCount';

import { useStyles } from './styles';

const Header = () => {
  const classes = useStyles();
  const history = useHistory();
  const { pathname } = history.location;
  const headerRef = useRef();

  const { order, setOrder } = useOrderContext();
  const { session, setSession } = useAuthContext();
  const { isLoading, setIsLoading } = useLoadingContext();
  const { setElementsCoords } = useElementsCoordsContext();
  const { toggleDrawer } = useDrawerContext();

  const result = order.reduce((tot, arr) => {
    // return the sum with previous value
    return tot + arr.qty;

    // set initial value as 0
  }, 0);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = event => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  const backToSliderScreen = () => history.goBack();
  const handleLogout = async () => {
    setAnchorEl(null);
    setIsLoading(true);
    if (session.staff && session.staff.checkedIn) {
      await staffCheckOut();
    }
    await deleteCookie();
    setSession({});
    setIsLoading(false);
    setOrder([]);
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = `https://waitless.ai`;
  };

  const headerInnerStyles = clsx(classes.headerInner, classes.spaceBetween);

  const backButtonStyles =
    pathname === '/' ||
    pathname.indexOf('service') >= 0 ||
    pathname.indexOf('visit') >= 0
      ? clsx(classes.backButton, classes.hidden)
      : classes.backButton;

  const headerLogoStyles =
    pathname.indexOf('service') < 0
      ? clsx(classes.headerLogo, classes.headerLogoCentered)
      : classes.headerLogo;

  const isDisplayInitials =
    pathname.indexOf('service') >= 0 && session?.staff?.initials;

  useEffect(() => {
    setElementsCoords({
      header: headerRef.current.getBoundingClientRect(),
    });
    // eslint-disable-next-line
  }, []);

  return (
    <header className={classes.header} ref={headerRef}>
      <Backdrop
        className={classes.backdrop}
        open={isLoading}
        onClick={() => false}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={headerInnerStyles}>
        {!session.staff ? (
          <button onClick={backToSliderScreen} className={backButtonStyles}>
            <img className={classes.headerImg} src={arrow} alt="arrow" />
          </button>
        ) : (
          <Avatar
            variant="rounded"
            className={classes.avatar}
            onClick={toggleDrawer}
          >
            <Menu fontSize="small" />
          </Avatar>
        )}
        <div className={headerLogoStyles}>
          <img src={penguin} className={classes.headerLogoImg} alt="penguin" />
          <span className={classes.headerLettering}>Waitless</span>
        </div>
        {session && (
          <div className={classes.headerBar}>
            <AvatarMenu
              initials={session?.staff?.initials}
              isDisplayInitials={isDisplayInitials}
              anchorEl={anchorEl}
              handleLogout={handleLogout}
              handleOpenMenu={handleOpenMenu}
              handleCloseMenu={handleCloseMenu}
            />
            <OrderCount result={result} />
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
